import convertLocaleStringToNumber from './convertLocaleStringToNumber';
import getCurrencyDisplay from './getCurrencyDisplay';
export default function getCurrencyStorage(value, currency) {
  var currencyDisplay = getCurrencyDisplay(value, currency);
  return convertLocaleStringToNumber(currencyDisplay).toString();
}